var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProgramming9362366(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-4{fill:none;stroke:#4d535b;stroke-miterlimit:10;stroke-width:2px}"))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 21h48v32H8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dee0e2",
    d: "M8 21v3h44v29h4V21H8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "stroke"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M25.1 30.9l-7.6 6.2 7.6 6.1m13.8-12.3l7.6 6.2-7.6 6.1m-4.5-15.3l-3.9 18.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M55.5 11.3h-47v41.4h47V11.3zm0 9.4h-47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M49.6 15.4a.9.9 0 00-1 1 1 1 0 001 1 1.1 1.1 0 001-1 1 1 0 00-1-1zm-6.7 0a.9.9 0 00-1 1 1 1 0 001 1 1.1 1.1 0 001-1 1 1 0 00-1-1z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "darken"
    },
    fill: "#a1f4c0",
    d: "M8 11h48v10H8z",
    id: "flah"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramming9362366);
export default __webpack_public_path__ + "static/media/programming.9362366.6ee5a90126f5bd6bb1a83b2465df5556.svg";
export { ForwardRef as ReactComponent };